import type { ComponentProps } from "react"

export default function PropertyOffice(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66667 5.33333C2.66667 4.59696 3.26363 4 4 4H28C28.7364 4 29.3333 4.59696 29.3333 5.33333V20H30.6667C31.4031 20 32 20.5969 32 21.3333V25.3333C32 26.0363 31.7599 26.7257 31.2428 27.2428C30.7257 27.7599 30.0363 28 29.3333 28H2.66667C1.96367 28 1.27423 27.7599 0.757191 27.2428C0.240152 26.7257 0 26.0363 0 25.3333V21.3333C0 20.5969 0.596953 20 1.33333 20H2.66667V5.33333ZM13.3333 22.6667V21.3333C13.3333 20.5969 12.7364 20 12 20H5.33333V6.66667H26.6667V20H20C19.2636 20 18.6667 20.5969 18.6667 21.3333V22.6667H13.3333Z"
        fill={fill}
      />
    </svg>
  )
}
